import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import settingsReducer from './settingsReducer'
import user from './user'
import appgeneral from './appGeneral'
import myapps from './myApps'
import appcontent from './appContent'
import admin from './adminGeneral'
import appmenus from './appMenus'
import formmaker from './formMaker'
import appschedule from './appSchedule'
import appreports from './appReports'

export default (history) =>  combineReducers({
  settings: settingsReducer,
  router: connectRouter(history),
  admin,
  user,
  appgeneral,
  appcontent,
  appmenus,
  myapps,
  formmaker,
  appreports,
  appschedule
})